import type { ReactNode } from 'react';

const SavedViewDropdownPanel = ({ children }: { children: ReactNode }) => (
    <div className="w-[240px] rounded-[8px] bg-white py-3 shadow-[0_6px_8px_rgba(0,0,0,0.08),0_3px_3px_rgba(0,0,0,0.12),0_9px_14px_rgba(0,0,0,0.05)]">
        {children}
    </div>
);

export default SavedViewDropdownPanel;
